import { tabbableSelector } from "$json/lib/keyboard";

$(document).on("bb:userError", () => {
  const fst = document.querySelector(
    ".group .validatable:not([aria-hidden=true])[aria-invalid=true]"
  );
  if (fst === null) return;
  if (fst.matches(tabbableSelector)) {
    fst.focus(); // NOTE: fails with complex widgets.
  } else {
    const focusable = fst.querySelector(tabbableSelector);
    focusable && focusable.focus();
  }
  (fst.closest(".bb-questionlabelgroup") || fst).scrollIntoView({
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth"
  });
});
